import { rei } from "@/services/api"

class UploadTemporarioService {
  static uploadTemporario (form) {
    return rei.post(`upload-temp`, form).then(res => res.data)
  }

  static deleteTemporario (url) {
    const payload = {
      url_s3: url
    }

    return rei.delete(`delete-temp`, { params: payload }).then(res => res.data)
  }

  static getTemp (url) {
    const payload = {
      url_s3: url
    }

    return rei.post('arquivo-temp', payload, {responseType: 'arraybuffer'}).then(res => res.data)
  }
}

export default UploadTemporarioService
